import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FAQ from "../Pages/FAQ";
import AuthLayout from "../Pages/auth/AuthLayout";
import ProtectedLayout from "../Pages/protected/ProtectedLayout";
import AddPatientdetails from "../Pages/protected/AddPatientDetails";
import AddPatient from "../Pages/protected/AddPatient";
import Tests from "../Pages/protected/Tests";
import TestPage from "../Pages/protected/TestPage";
import ReportPage from "../Pages/protected/ReportPage";
import EntUploadSummary from "../Pages/protected/EntUploadSummary";
import SystemPage from "../Pages/protected/SystemPage";
import PaymentLayout from "../Pages/protected/payment/PaymentLayout";
import Method1 from "../Pages/protected/payment/Method1";
import AppPaymentPage from "../Pages/protected/payment/Method2";
import WebPaymentPage from "../Pages/protected/payment/Method3";
import AddressProof from "../Pages/protected/payment/AddressProof";
import Confirmation from "../Pages/protected/payment/Confirmation";
import LoginPage from "../Pages/auth/LoginPage";
import GeneralTest from "../Pages/protected/GeneralTest";
import ForgotPassword from "../Pages/auth/ForgotPassword";
import BodyComposition from "../Pages/protected/BodyComposition";
import SearchPatient from "../Pages/protected/SearchPatient";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import Notification from "../Pages/protected/Notification";
import TestParameter from "../Pages/protected/TestParameter";
import CoughTestModal from "../Pages/protected/CoughTestModal";
import TermsandCondition from "../Pages/TermsandCondition";
import Refund from "../Pages/Refund";

const AllRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/faq" element={<FAQ />} />
      <Route path="appPayment" element={<AppPaymentPage />} />
      <Route path="webPayment" element={<WebPaymentPage />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-condition" element={<TermsandCondition />} />
      <Route path="/refund-and-cancellation" element={<Refund />} />

      {/* Authentication Routes */}
      <Route path="/auth" element={<AuthLayout />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
      </Route>

      {/* Protected Routes */}
        <Route path="/" element={<ProtectedLayout />}>
        {/* Default route if base path is accessed */}
        <Route path="/" element={<Navigate to="add-patient" replace />} />
        <Route path="/testparameter" element={<TestParameter />} />
        <Route path="/cough-test" element={<CoughTestModal />} />
        <Route path="add-patient" element={<AddPatient />} />
        <Route path="add-patientdetails" element={<AddPatientdetails />} />
        <Route path="tests" element={<Tests />} />
        <Route path="tests/:testId" element={<TestPage />} />
        <Route path="tests/:testId/report" element={<ReportPage />} />
        <Route path="ent-upload-summary" element={<EntUploadSummary />} />
        <Route path="system" element={<SystemPage />} />
        <Route path="general-test" element={<GeneralTest />} />
        <Route path="search-patient" element={<SearchPatient />} />
        <Route path="notifications" element={<Notification />} />
        <Route path="body-composition" element={<BodyComposition />} />

        {/* Nested Payment Routes */}
        <Route path="payment" element={<PaymentLayout />}>
          <Route path="method1" element={<Method1 />} />
          <Route path="address" element={<AddressProof />} />
          <Route path="confirmation" element={<Confirmation />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/auth/login" replace />} />
    </Routes>
  );
};

export default AllRoutes;
